import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyledTopMargin, StyledContent, StyledErrorText, StyledResendButon } from './styles';
import { loginWithMobile, verifyUserOTP, clearUserError } from '../../../redux/slices/UserSlice';
import { Button, Loader } from '../../atoms';
import { LoginVerify } from '../../containers';
import { IOTPPage } from './types';
import { FirebaseCaptcha } from '../../../../../../adapters/provider';
import useSegment from '../../../../../../utils/hooks/useSegment';
import { SEGMENT_ACTIONS } from '../../../../../../utils/constants/SegmentActionConstants';

const OTPPage: React.FunctionComponent<IOTPPage> = ({ mobile, goBack }) => {
    const dispatch = useDispatch();
    const trackTask = useSegment('task');
    const [otp, setOtp] = React.useState('');
    const userData = useSelector((state: any) => state.user.userData);
    const enteredMobile = useSelector((state: any) => state.user.userMobile.data || '');
    React.useEffect(() => {
        if (!userData.loading && !userData.error && userData.data) {
            const segmentAction = SEGMENT_ACTIONS.TASK.LOGIN_SUCCESS;
            trackTask({
                name: segmentAction.name,
                properties: {
                    login_method: (segmentAction.properties?.login_method as (loginMethod: string) => string)(
                        userData.loginMethodType
                    )
                }
            });
        } else if (!userData.loading && userData.error) {
            const segmentAction = SEGMENT_ACTIONS.TASK.LOGIN_FAIL;
            trackTask({
                name: segmentAction?.name ?? '',
                properties: {
                    login_method: (segmentAction.properties?.login_method as (loginMethod: string) => string)(
                        userData.loginMethodType
                    )
                }
            });
        }
    }, [userData]);
    const goBackClick = () => {
        goBack();
    };
    const verifyOTP = () => {
        dispatch(clearUserError());
        if (window.confirmationResult?.confirm && otp) {
            dispatch(verifyUserOTP({ otp, enteredMobile }));
        } else {
            goBackClick();
        }
    };
    const resendOTP = () => {
        dispatch(clearUserError());
        window.recaptchaVerifier = new FirebaseCaptcha.RecaptchaVerifier('resend-otp', {
            size: 'invisible'
        });
        if (mobile) dispatch(loginWithMobile(mobile));
    };
    return (
        <StyledContent>
            <LoginVerify showMobileForm={true} phoneNumber={mobile} getOtp={setOtp} goBack={goBack} />
            {userData.error && <StyledErrorText>{userData.error.message}</StyledErrorText>}
            <StyledTopMargin>
                <Button type="primary" disabled={!(otp.length === 6)} onClick={verifyOTP} fullWidth={true}>
                    {userData.loading ? <Loader inverted /> : 'Verify'}
                </Button>
                <StyledResendButon id={'resend-otp'} onClick={resendOTP}>
                    Resend OTP
                </StyledResendButon>
            </StyledTopMargin>
        </StyledContent>
    );
};

export default OTPPage;
